import { Activity } from "../../../../models/activity/activity";
import { KeyValueObject } from "../../../../models/core/KeyValueObject";

export class CompleteActivityResultPropertiesData {
    
    activity: Activity = null;
    activityResults: KeyValueObject[] = [];
    activityResultId: number;
    completedDateTime: Date;
}